const newFilterDefinitions = [{
  filterId: 'billingModel',
  label: 'Billing',
  isMulti: true,
  isSearchable: false,
  hiddenByDefault: false,
  hasClearSelectionButton: true,
  groupSelectedItems: true
}];
export const defaultFilterDefinitions = [{
  filterId: 'product',
  label: 'Product',
  isMulti: false,
  isSearchable: false,
  hiddenByDefault: false,
  hasClearSelectionButton: true,
  groupSelectedItems: false
}, {
  filterId: 'hosting',
  label: 'Hosting',
  isMulti: false,
  isSearchable: false,
  hiddenByDefault: false,
  hasClearSelectionButton: true,
  groupSelectedItems: false
}, {
  filterId: 'price',
  label: 'Pricing',
  isMulti: true,
  isSearchable: false,
  hiddenByDefault: false,
  hasClearSelectionButton: true,
  groupSelectedItems: true
}, {
  filterId: 'trustSignals',
  label: 'Trust signals',
  isMulti: true,
  isSearchable: false,
  hiddenByDefault: false,
  hasClearSelectionButton: true,
  groupSelectedItems: true
}, {
  filterId: 'categories',
  label: 'Categories',
  isMulti: false,
  isSearchable: true,
  hiddenByDefault: true,
  hasClearSelectionButton: true,
  groupSelectedItems: false
}, {
  filterId: 'useCases',
  label: 'Use cases',
  isMulti: true,
  isSearchable: true,
  hiddenByDefault: true,
  hasClearSelectionButton: true,
  groupSelectedItems: true
}, {
  filterId: 'other',
  label: 'More filters',
  isMulti: true,
  isSearchable: false,
  hiddenByDefault: true,
  hasClearSelectionButton: true,
  groupSelectedItems: true
}];
export const transformedDefaultFilterDefinitions = () => {
  const result = [...defaultFilterDefinitions];
  result.splice(3, 0, ...newFilterDefinitions);
  return result;
};